const Chips = ({ value, className, valueClassName }) => {
  return (
    <div className={`${className} rounded-md pt-1 pb-1 h-max`}>
      <span className={`${valueClassName}`}>{value}</span>
    </div>
  );
};

export default Chips;
